import apiClient from '../utils/apiClient';

const service = '/Service';

// Get all service summaries
export const getAllServiceSummaries = async () => {
  try {
    const response = await apiClient.get(`${service}/Summary`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service summaries:', error);
    throw new Error(
      error.response?.data?.message || 'Error fetching service summaries'
    );
  }
};

// Create a new service summary (if applicable)
export const createServiceSummary = async serviceSummaryData => {
  try {
    const response = await apiClient.post(
      `${service}/Summary`,
      serviceSummaryData
    );
    return response.data;
  } catch (error) {
    console.error('Error creating service summary:', error);
    throw new Error(
      error.response?.data?.message || 'Error creating service summary'
    );
  }
};

// Update an existing service summary
export const updateServiceSummary = async (id, formData) => {
  try {
    const response = await apiClient.put(
      `${service}/Summary?id=${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Dosya gönderimi için header
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating service summary:', error);
    throw new Error(
      error.response?.data?.message || 'Error updating service summary'
    );
  }
};

// Delete a service summary by ID
export const deleteServiceSummaryById = async id => {
  try {
    const response = await apiClient.delete(`${service}/Summary?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting service summary:', error);
    throw new Error(
      error.response?.data?.message || 'Error deleting service summary'
    );
  }
};
